import { CHANGE_GIA_ITEM, BLUR_GIA_ITEM } from '../constants';

export const changeGiaItem = payload => ({ type: CHANGE_GIA_ITEM, payload });

export const blurGiaItem = payload => ({ type: BLUR_GIA_ITEM, payload });

export default changeGiaItem;
